import useInterval from '@restart/hooks/useInterval';
import classNames from 'classnames/bind';
import React, { useState } from 'react';

import styles from './RetryImage.module.scss';
import Spinner from './Spinner';

const cx = classNames.bind(styles);

const RetryImage = ({ src, retryInterval = 3000, alt }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [isIntervalPaused, setIntervalPaused] = useState(true);
  const [isLoading, setLoading] = useState(true);

  useInterval(
    () => {
      // Add timestamp to trigger retry
      setImageSrc(`${src}#${Date.now()}`);
    },
    retryInterval,
    isIntervalPaused
  );

  const handleImageLoad = () => {
    setLoading(false);
    setIntervalPaused(true);
  };

  const handleImageError = () => {
    setLoading(true);
    setIntervalPaused(false);
  };

  return (
    <div className={cx('container')}>
      <img
        src={imageSrc}
        onLoad={handleImageLoad}
        onError={handleImageError}
        alt={alt}
        className={cx(['image', { hidden: isLoading }])}
      />
      {isLoading && (
        <div className={cx('placeholder')}>
          <Spinner color="rgba(255, 255, 255, 0.6)" />
        </div>
      )}
    </div>
  );
};

export default RetryImage;
